
 
export const FETCH_FORMS_REQUEST = 'forms/FETCH_FORMS_REQUEST';
export const FETCH_FORMS_SUCCESS = 'forms/FETCH_FORMS_SUCCESS';
export const FETCH_FORMS_FAILURE = 'forms/FETCH_FORMS_FAILURE';

 
export const FETCH_FORM_REQUEST = 'forms/FETCH_FORM_REQUEST';
export const FETCH_FORM_SUCCESS = 'forms/FETCH_FORM_SUCCESS';
export const FETCH_FORM_FAILURE = 'forms/FETCH_FORM_FAILURE';

 
export const DELETE_FORM_REQUEST = 'forms/DELETE_FORM_REQUEST';
export const DELETE_FORM_SUCCESS = 'forms/DELETE_FORM_SUCCESS';
export const DELETE_FORM_FAILURE = 'forms/DELETE_FORM_FAILURE';

 
export const CREATE_FORM_REQUEST = 'forms/CREATE_FORM_REQUEST';
export const CREATE_FORM_SUCCESS = 'forms/CREATE_FORM_SUCCESS';
export const CREATE_FORM_FAILURE = 'forms/CREATE_FORM_FAILURE';

 
export const UPDATE_FORM_REQUEST = 'forms/UPDATE_FORM_REQUEST';
export const UPDATE_FORM_SUCCESS = 'forms/UPDATE_FORM_SUCCESS';
export const UPDATE_FORM_FAILURE = 'forms/UPDATE_FORM_FAILURE';


export const UPDATE_FIELD = 'forms/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'forms/SET_DEFAULT_DATA';
